import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Badge,
  Chip,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { styles, getInitials, stringToColor } from "./broadcastLive.styles";

const UsersPanel = ({ onlineUsers }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={styles.usersPanelContainer(isMobile)}>
      <Box sx={styles.usersPanelHeader(isMobile)}>
        <PeopleAltIcon sx={{ color: theme.palette.primary.main }} />
        <Typography variant="subtitle1" fontWeight={600} color="text.primary">
          Conectadas
        </Typography>
        <Chip
          label={onlineUsers.length}
          size="small"
          sx={styles.usersPanelChip(theme)}
        />
      </Box>

      <List sx={styles.usersList}>
        {onlineUsers
          ?.slice()
          .reverse()
          .map((item, index) => (
            <ListItem key={index} sx={styles.userItem}>
              <ListItemAvatar sx={{ minWidth: 40 }}>
                <Badge
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  badgeContent={<CircleIcon sx={styles.onlineBadge} />}
                >
                  <Avatar sx={styles.userAvatar(item?.name, item?.lastname)}>
                    {getInitials(item?.name, item?.lastname)}
                  </Avatar>
                </Badge>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography
                    variant="body2"
                    fontWeight={500}
                    color="text.primary"
                    noWrap
                  >
                    {item?.name} {item?.lastname}
                  </Typography>
                }
              />
            </ListItem>
          ))}
      </List>
    </Box>
  );
};

export default UsersPanel;
